<template>
  <div>
    <DxForm ref="formInstance" :form-data="model" label-location="top" :show-colon-after-label="false"
      :visible="model != null" validation-group="validacionInmueble" class="mt-4 mb-4">
      <DxColCountByScreen :xs="6" :sm="6" :md="6" :lg="6" />

      <!-- Responsable del inmueble -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{ $t('inmueble.ui.responsableInmueble') }}</span>
        </DxSimpleItem>
        <DxSimpleItem data-field="IdDelegacionInmobiliaria" editor-type="dxSelectBox" :col-span="3"
          :editor-options="{ ...getSelectBoxDefaultProperties(), ...delegacionOptions }">
          <DxLabel :text="$t('inmueble.delegacion')" />
          <DxRequiredRule :message="$t('inmueble.validations.delegacion')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="IdAgenteResponsable" editor-type="dxSelectBox" :col-span="3"
          :editor-options="{ ...getSelectBoxDefaultProperties(), ...agenteOptions }">
          <DxLabel :text="$t('inmueble.agenteResponsable')" />
          <DxRequiredRule :message="$t('inmueble.validations.agenteResponsable')" />
        </DxSimpleItem>
      </DxGroupItem>

      <!-- Tipo de inmueble y datos básicos -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{ $t('inmueble.ui.tipologiaInmueble') }}</span>
        </DxSimpleItem>
        <DxSimpleItem data-field="TipoInmueble" editor-type="dxSelectBox" :col-span="2"
          :editor-options="getDomainEnumSelectBox('tipoInmueble', 'values')">
          <DxLabel :text="$t('inmueble.tipoInmueble')" />
          <DxRequiredRule :message="$t('inmueble.validations.tipoInmueble')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="TipoObra" editor-type="dxSelectBox" :col-span="2"
          :editor-options="getDomainEnumSelectBox('tipoObra', 'values')">
          <DxLabel :text="$t('inmueble.tipoObra')" />
          <DxRequiredRule :message="$t('inmueble.validations.tipoObra')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="CapacidadMaxima" editor-type="dxNumberBox" :col-span="2"
          :editor-options="capacidadNumberOptions">
          <DxLabel :text="$t('inmueble.capacidadMaxima')" />
          <DxRequiredRule :message="$t('inmueble.validations.capacidadMaxima')" />
        </DxSimpleItem>
      </DxGroupItem>

      <!-- Tipologia de instalaciones -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{ $t('inmueble.ui.tipologiaInstalaciones') }}</span>
        </DxSimpleItem>
        <DxSimpleItem :col-span="2">
          <DxRadioGroup v-model="model.TipoCalentador" :items="opcionesCalentador" value-expr="valor" display-expr="texto"
            layout="horizontal" />
          <DxLabel :text="$t('inmueble.tipoCalentador')" />
        </DxSimpleItem>
        <DxSimpleItem :col-span="2">
          <DxRadioGroup v-model="model.TipoCalefaccion" :items="opcionesCalefaccion" value-expr="valor"
            display-expr="texto" layout="horizontal" />
          <DxLabel :text="$t('inmueble.tipoCalefaccion')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2"></DxEmptyItem>
        <DxSimpleItem :col-span="2">
          <DxRadioGroup v-model="model.TipoCocina" :items="opcionesCocina" value-expr="valor" display-expr="texto"
            layout="horizontal" />
          <DxLabel :text="$t('inmueble.tipoCocina')" />
        </DxSimpleItem>
        <DxSimpleItem :col-span="2">
          <DxCheckBox v-model="model.TieneCalefaccionCentral" :text="$t('inmueble.tieneCalefaccionCentral')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2"></DxEmptyItem>
      </DxGroupItem>

      <!-- Dirección física -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{ $t('inmueble.ui.direccionFisica') }}</span>
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.CodigoPostal" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('direccion.codigoPostal')" />
          <DxRequiredRule :message="$t('direccion.validations.codigoPostalRequerido')" />
          <DxPatternRule :pattern="codigoPostalPattern" :message="$t('direccion.validations.codigoPostal')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Provincia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('direccion.provincia')" />
          <DxRequiredRule :message="$t('direccion.validations.provinciaRequerida')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Municipio" editor-type="dxTextBox" :col-span="3">
          <DxLabel :text="$t('direccion.municipio')" />
          <DxRequiredRule :message="$t('direccion.validations.municipioRequerido')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.TipoVia" editor-type="dxTextBox" :col-span="2">
          <DxLabel :text="$t('direccion.tipoVia')" />
          <DxRequiredRule :message="$t('direccion.validations.tipoViaRequerido')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.NombreVia" editor-type="dxTextBox" :col-span="4">
          <DxLabel :text="$t('direccion.nombreVia')" />
          <DxRequiredRule :message="$t('direccion.validations.nombreViaRequerido')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Numero" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('direccion.numero')" />
          <DxRequiredRule :message="$t('direccion.validations.numeroRequerido')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Escalera" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('direccion.escalera')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Piso" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('direccion.piso')" />
        </DxSimpleItem>
        <DxSimpleItem data-field="Direccion.Puerta" editor-type="dxTextBox" :col-span="1">
          <DxLabel :text="$t('direccion.puerta')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2"></DxEmptyItem>
      </DxGroupItem>

      <!-- Datos de suministro -->
      <DxGroupItem :col-count="6" :col-span="6">
        <DxSimpleItem :col-span="6">
          <span class="dx-field-item-label-text text-success">{{ $t('inmueble.ui.suministros') }}</span>
        </DxSimpleItem>
        <DxSimpleItem :col-span="2">
          <DxCheckBox v-model="model.TieneServicioLuz" :text="$t('inmueble.servicios.luz')" />
          <DxLabel :visible="false" />
        </DxSimpleItem>
        <DxSimpleItem :col-span="2">
          <DxCheckBox v-model="model.TieneServicioGas" :text="$t('inmueble.servicios.gas')" />
          <DxLabel :visible="false" />
        </DxSimpleItem>
        <DxSimpleItem :col-span="2">
          <DxCheckBox v-model="model.TieneServicioAgua" :text="$t('inmueble.servicios.agua')" />
          <DxLabel :visible="false" />
        </DxSimpleItem>
        <DxSimpleItem :col-span="2" :visible="model.TieneServicioLuz">
          <DxRadioGroup v-model="disponeCupsLuz" :items="radioYesNoValues" value-expr="valor" display-expr="texto"
            layout="horizontal" validation-message-mode="always" >
          </DxRadioGroup>
          <DxLabel :text="$t('inmueble.dispongo_cups')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2" :visible="!model.TieneServicioLuz"></DxEmptyItem>
        <DxSimpleItem :col-span="2":visible="model.TieneServicioGas">
          <DxRadioGroup v-model="disponeCupsGas" :items="radioYesNoValues" value-expr="valor" display-expr="texto"
            layout="horizontal" validation-message-mode="always" >
          </DxRadioGroup>
          <DxLabel :text="$t('inmueble.dispongo_cups')" />
        </DxSimpleItem>
        <DxEmptyItem :col-span="2" :visible="!model.TieneServicioGas"></DxEmptyItem>
        <DxEmptyItem :col-span="2"></DxEmptyItem>
        <DxGroupItem :col-count="6" :col-span="6">
          <DxEmptyItem :col-span="2" :visible="!model.TieneServicioLuz || !disponeCupsLuz"></DxEmptyItem>
          <DxSimpleItem data-field="CupsLuz" editor-type="dxTextBox" :col-span="2" :visible="model.TieneServicioLuz && disponeCupsLuz">
            <DxLabel :text="$t('inmueble.cupsLuz')" />
            <DxPatternRule :pattern="cupsPattern" :message="$t('wizard.step4.validacion.cups_patron')" />
            <DxRequiredRule :message="$t('wizard.step4.validacion.cups')" />
          </DxSimpleItem>
          <DxEmptyItem :col-span="2" :visible="!model.TieneServicioGas || !disponeCupsGas"></DxEmptyItem>
          <DxSimpleItem data-field="CupsGas" editor-type="dxTextBox" :col-span="2" :visible="model.TieneServicioGas && disponeCupsGas">
            <DxLabel :text="$t('inmueble.cupsGas')" />
            <DxPatternRule :pattern="cupsPattern" :message="$t('wizard.step4.validacion.cups_patron')" />
            <DxRequiredRule :message="$t('wizard.step4.validacion.cups')" />
          </DxSimpleItem>
          <DxEmptyItem :col-span="2"></DxEmptyItem>
        </DxGroupItem>
      </DxGroupItem>
    </DxForm>
  </div>
</template>

<script setup lang="ts">
import { ref, watch, onMounted, computed } from 'vue';
import { DxForm, DxItem, DxEmptyItem, DxLabel, DxColCountByScreen, DxRequiredRule, DxPatternRule, DxGroupItem, DxSimpleItem } from "devextreme-vue/form";
import { DxCheckBox, DxRadioGroup } from 'devextreme-vue';
import { CreateInmueble } from './models/CreateInmueble';
import { getSelectBoxDefaultProperties, getDomainEnumSelectBox } from '@helpers/grid-helper';
import { useApi } from '@api/integration';
import validationEngine from "devextreme/ui/validation_engine";
import { useIntl } from '@/.shared/services/i18n';

const api = useApi();
const cupsPattern = ref<RegExp>(/^.{20}$|^.{22}$/);
const delegaciones = ref<any[]>([]);
const agentes = ref<any[]>([]);
const intl = useIntl();

// Opciones para las instalaciones
const opcionesCalentador = [
  { valor: 'ELECTRICO', texto: intl.i18n.t("tipoCalentador.values.ELECTRICO") },
  { valor: 'GAS', texto: intl.i18n.t("tipoCalentador.values.GAS") }
];

const opcionesCalefaccion = [
  { valor: 'ELECTRICA', texto: intl.i18n.t("tipoCalefaccion.values.ELECTRICA") },
  { valor: 'GAS', texto: intl.i18n.t("tipoCalefaccion.values.GAS") }
];

const opcionesCocina = [
  { valor: 'ELECTRICA', texto: intl.i18n.t("tipoCocina.values.ELECTRICA") },
  { valor: 'GAS', texto: intl.i18n.t("tipoCocina.values.GAS") },
  { valor: 'MIXTA', texto: intl.i18n.t("tipoCocina.values.MIXTA") }
];

const radioYesNoValues = [
  { valor: true, texto: intl.i18n.t("shared.ui.literals.yes") },
  { valor: false, texto: intl.i18n.t("shared.ui.literals.no") },
];

const props = defineProps({
  model: {
    type: Object as () => CreateInmueble,
    required: true
  }
});

const delegacionOptions = ref({
  dataSource: delegaciones
});

const agenteOptions = computed(() => ({
  dataSource: agentes.value,
  disabled: !props.model.IdDelegacionInmobiliaria
}));

const capacidadNumberOptions = {
  showSpinButtons: true,
  step: 1,
  min: 0,
};

const disponeCupsLuz = ref<boolean>(props.model.CupsLuz != null);
const disponeCupsGas = ref<boolean>(props.model.CupsGas != null);

const formInstance = ref<DxForm>();
const codigoPostalPattern = ref(/^\d{5}$/);

onMounted(async () => {
  await cargarDelegaciones();
});

watch(() => props.model.IdDelegacionInmobiliaria, async (newValue) => {
  if (newValue) {
    await cargarAgentes(newValue);
  } else {
    agentes.value = [];
    props.model.IdAgenteResponsable = null;
  }
}, { immediate: true });

watch(() => props.model.CupsLuz, (newValue) => {
  disponeCupsLuz.value = newValue != null;
});

watch(() => props.model.CupsGas, (newValue) => {
  disponeCupsGas.value = newValue != null;
});

watch(() => disponeCupsLuz.value, (newValue) => {
  if (!newValue) {
    props.model.CupsLuz = null;
  }
});

watch(() => disponeCupsGas.value, (newValue) => {
  if (!newValue) {
    props.model.CupsGas = null;
  }
});

const isValid = () => {
  return validationEngine.validateGroup("validacionInmueble").isValid;
};

defineExpose({
  isValid
});

async function cargarDelegaciones() {
  try {
    const response = await api.callStandardApi("getDelegacionInmobiliariaSelector", { showLoading: true });
    delegaciones.value = response;
  } catch (error) {
    console.error('Error al cargar delegaciones:', error);
  }
}

async function cargarAgentes(idDelegacion: string) {
  try {
    const response = await api.callStandardApi("getAgentesInmobiliariaByDelegacionSelector", { showLoading: true }, idDelegacion);
    agentes.value = response;
  } catch (error) {
    console.error('Error al cargar agentes:', error);
  }
}

</script>
